import styled from 'styled-components';

export const CustomSection = styled.div`
  padding: 40px 50px;
  @media (max-width: 1023px) {
    padding: 0 25px 40px;
  }
`;